import { ForgottenPasswordForm } from 'src/components';

export const ForgottenPassword = () => {
    return <ForgottenPasswordForm />;
};
